<template>
  <div class="rtd_content">
    <!-- <div class="rtd_desc" v-if="recruitDeail.Content == ''">
      <div class="desc_label">任务详情</div>

      <div class="article">
        <div class="article-body">
          <div class="article-intro" v-html="recruitDeail.Message"></div>
        </div>
      </div>
    </div> -->

    <!-- <div class="rtd_desc" v-else-if="recruitDeail.Content != ''"> -->
    <div class="rtd_desc">
      <div class="desc_label">任务详情</div>

      <div class="article">
        <div class="article-body">
          <div class="article-intro">
            <h1>{{ recruitDeail.Title }}</h1>
            <h3>发布时间：{{ recruitDeail.TimeDesc || "/" }}</h3>
            <h2>任务报酬：</h2>
            <p>{{ recruitDeail.Salary || "/" }}</p>
            <h2>联系方式：</h2>
            <p>{{ recruitDeail.ContactInfo || "/" }}</p>
            <h2>任务描述：</h2>
            <p>{{ recruitDeail.Description || "/" }}</p>
            <h2>任务状态</h2>
            <p>{{ recruitDeail.Status | filterStatus }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/config/font-awesome.css";
import "@/config/style.css";
import { getTempDetail } from "@/config/api.js";
export default {
  data() {
    return {
      recruitDeail: {},
    };
  },
  beforeMount() {
    var that = this;
    var queryData = this.$route.query;
    if (queryData.hasOwnProperty("article")) {
      that.requestGetJobDetail(queryData.article);
    }
  },
  methods: {
    // 查询jobDetail
    requestGetJobDetail(article) {
      var that = this;
      var params = {
        slug: article,
      };
      getTempDetail(params).then((res) => {
        if (res.data) {
          that.recruitDeail = res.data;
        }
      });
    },
    // 返回上一页
    getBack() {
      var that = this;
      that.$router.go(-1);
    },
  },
  filters: {
    filterStatus(val) {
      if (val != "" && val != null && val != undefined) {
        if (val == 1) {
          return "进行中";
        } else if (val == 5) {
          return "已结束";
        } else {
          return "/";
        }
      }
      else {
        return "/";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rtd_content {
  width: 100%;
  min-height: 100vh;
  height: auto;
  background: #f6f6f6;
  padding: 60px 0 18px 0;

  .rtd_desc {
    width: auto;
    height: auto;
    min-height: 608px;
    background: #ffffff;
    box-shadow: 0px 14px 20px 0px rgba(20, 65, 153, 0.05);
    border-radius: 8px 8px 8px 8px;

    margin: 18px 18.75% 0 18.75%;
    padding: 39px 47px 39px 47px;

    .desc_label {
      font-family: 2, 20;
      font-weight: normal;
      font-size: 24px;
      color: #689bff;
      line-height: 34px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin: 0 0 23px 0;
    }
  }
}

@media screen and (max-width: 958px) {
  .rtd_content {
    width: 100%;
    min-height: 100vh;
    height: auto;
    background: #f6f6f6;
    padding: 60px 0 18px 0;

    .rtd_desc {
      width: auto;
      height: auto;
      min-height: 608px;
      background: #ffffff;
      box-shadow: 0px 14px 20px 0px rgba(20, 65, 153, 0.05);
      border-radius: 8px 8px 8px 8px;

      margin: 18px 5% 0 5%;
      padding: 20px 24px 20px 24px;

      .desc_label {
        font-family: 2, 20;
        font-weight: normal;
        font-size: 18px;
        color: #689bff;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin: 0 0 23px 0;
      }
    }
  }
}
</style>